import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';

// Models
import { MinimumValueToPayType, TotalAmountType } from '../models';
import DetailCredit from '@model/detailCredit/detailCredit';
import ConfigurationSystem from '@model/pay/configuration-system';

// Environments
import { environment } from '@environments/environment';

import { getHttpHeaders } from '@commons/utility/util';
import { routes } from '@model/constants/routes';

@Injectable({
  providedIn: 'root',
})
export class ValueToPayService {
  private readonly apiDailyBalance: string;
  private readonly apiUrl = environment.apiUrl;
  private readonly headers = getHttpHeaders();

  constructor(private readonly httpClient: HttpClient) {
    this.apiDailyBalance = environment.apiDailyBalance;
  }

  public getAmount(loanId: string | number): Observable<TotalAmountType> {
    let headers = this.httpOptions();
    return this.httpClient.get<TotalAmountType>(`${this.apiDailyBalance}v2/balance/total-amount/${loanId}`, {
      headers,
    });
  }

  public getMinimumPayment(loanId: string | number): Observable<MinimumValueToPayType> {
    let headers = this.httpOptions();
    return this.httpClient.get<MinimumValueToPayType>(`${this.apiDailyBalance}v2/balance/minimum-amount/${loanId}`, {
      headers,
    });
  }

  private httpOptions(): HttpHeaders {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return headers;
  }

  public getDetailsCredit(loanId: string) {
    return this.httpClient.get<{ response: DetailCredit }>(this.apiUrl + routes.getDetailsCredit + loanId, {
      headers: this.headers,
    });
  }

  public getConfigurationSystem(group: string, product: string) {
    return this.httpClient.get<{ response: Array<ConfigurationSystem> }>(
      this.apiUrl + routes.getConfigurationSystem + group + '/product/' + product,
      {
        headers: this.headers,
      }
    );
  }
}
